import { connect } from 'react-redux';
import { Search } from '../components/index';
import { updateTagSearchText } from '../actions';

const mapStateToProps = state => ({
  searchText: state.tagSearchText,
  suggestions: [],
});

const mapDispatchToProps = dispatch => (
  {
    updateSearchText: ({ searchText }) => {
      dispatch(updateTagSearchText({ searchText }));
    },
  }
);

const TagSearch = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Search);

export default TagSearch;



// WEBPACK FOOTER //
// ./src/containers/TagSearch.js